import { type Component, Show } from "solid-js";
import { TextAndIconButton, type TextAndIconButtonProps } from "../button/Button";
import type { EmptyStateIllustrationProps } from "./EmptyStateIllustration";
import EmptyStateIllustration from "./EmptyStateIllustration";
import { isNil } from "lodash-es";
import type { ListItemMenuItems, ListItemMenuSize } from "../listItemMenu/ListItemMenu";
import { ListItemMenu } from "../listItemMenu/ListItemMenu";
import type { Placement } from "@floating-ui/utils";

export type EmptyStateProps = {
  title: string;
  description: string;
  illustration?: EmptyStateIllustrationProps;
  action?: Pick<TextAndIconButtonProps, "variant" | "text" | "icon" | "onClick"> & {
    items?: ListItemMenuItems<string>;
    placement?: Placement;
    menuSize?: ListItemMenuSize;
  };
  class?: string;
};

const EmptyState: Component<EmptyStateProps> = (props) => (
  <div
    class="flex size-full flex-col items-center gap-y-4 rounded-sm py-6 text-center"
    classList={{ [`${props.class}`]: !isNil(props.class) }}
  >
    <Show when={props.illustration}>{(illustrationProps) => <EmptyStateIllustration {...illustrationProps()} />}</Show>
    <hgroup class="flex max-w-85 flex-col">
      <h3 class="text-header-lg text-primary">{props.title}</h3>
      <p class="mt-1 text-medium-regular text-secondary">{props.description}</p>
    </hgroup>

    <Show when={props.action}>
      {(actionProps) => (
        <Show when={props.action?.items} fallback={<TextAndIconButton {...actionProps()} />}>
          {(items) => (
            <ListItemMenu
              menu={{
                size: actionProps().menuSize ?? "md",
                positioning: {
                  placement: actionProps().placement ?? "bottom-end",
                },
              }}
              trigger={(menuTriggerProps) => <TextAndIconButton {...actionProps()} {...menuTriggerProps} />}
              items={items()}
            />
          )}
        </Show>
      )}
    </Show>
  </div>
);

export default EmptyState;
